import api from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import type { ApiResponse, PulseOnboardingResult } from '@/types';

export const pulseOnboardingService = {
  /**
   * Start the Pulse ticket import for an account.
   *
   * There is no matching read. The import's progress lives in Pulse's own
   * `onboarding_status`, which this app does not surface, so the only thing to show is
   * what this call answered.
   */
  async start(accountId: number): Promise<PulseOnboardingResult> {
    const res = await api.post<ApiResponse<PulseOnboardingResult>>(
      API_ENDPOINTS.PULSE_ONBOARDING.START(accountId)
    );
    return res.data.data;
  }
};
